module.exports = __webpack_public_path__ + "img/TFSK_EarthDark.eb484159.png";